import { Rda } from '.'

export class ObrigacaoAplicacao {

  id: number;
  rda: Rda;
  fundoInvestimento: number;
  investidoAuditoria: number
  ;
}
